import { registerComponent } from '../app'
import { OPEN_QUICK_BUY, CLOSE_QUICK_BUY, OPEN_CART } from '../events'

const ProductPreview = (scope, el) => {
	const props = {
		overlayClass: 'overlay-open',
		animationLength: 250
	}

	const els = {
		toggles: el.querySelectorAll('[data-overlay-toggle]'),
		overlayWrap: el.querySelector('[data-overlay-wrap]'),
		overlay: el.querySelector('[data-overlay]')
	}

	els.overlayWrap.addEventListener('click', e => {
		e.stopPropagation()
	})

	for (let i = 0; i < els.toggles.length; i++) {
		els.toggles[i].addEventListener('click', e => {
			e.preventDefault()
			e.stopPropagation()
			if (el.classList.contains(props.overlayClass)) {
				close()
				return
			}
			open()
		})
	}

	function open() {
		scope.emit(OPEN_QUICK_BUY, els.overlay)
		el.classList.add(props.overlayClass)
	}

	function close() {
		scope.emit(CLOSE_QUICK_BUY)
		el.classList.remove(props.overlayClass)
		setTimeout(() => {
			els.overlayWrap.appendChild(els.overlay)
		}, props.animationLength)
	}

	el.addEventListener('addedToCart', () => {
		el.classList.remove(props.overlayClass)
	})

	scope.on(OPEN_CART, close)
}

registerComponent('product-preview', ProductPreview)
